import { Box, BoxProps, SxProps, Theme } from "@mui/material";
import { motion } from "framer-motion";
import { SkeletonBlockVariant } from "./interfaces/skeleton.interfaces";


interface SkeletonBlockProps extends Omit<BoxProps, "children"> {
    width?: number | string;
    height?: number | string;
    variant?: SkeletonBlockVariant;
    radius?: number | string;
    sx?: SxProps<Theme>;
}

export const SkeletonBlock = ({
    width = "100%",
    height = 16,
    variant = "rounded",
    radius,
    sx,
    ...props
}: SkeletonBlockProps) => {
    const getBorderRadius = () => {
        if (radius !== undefined) return radius;

        switch (variant) {
            case "rect":
                return 0;
            case "circle":
            case "pill":
                return "999px";
            case "rounded":
            default:
                return 2;
        }
    };

    return (
        <Box
            {...props}
            aria-hidden
            sx={[
                {
                    width,
                    height,
                    borderRadius: getBorderRadius(),
                    bgcolor: "rgba(148, 163, 184, 0.16)",
                    overflow: "hidden",
                    position: "relative",
                },
                ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
            ]}
        >
            <motion.div
                initial={{ opacity: 0.45 }}
                animate={{ opacity: [0.45, 1, 0.45] }}
                transition={{
                    duration: 1.35,
                    repeat: Infinity,
                    ease: "easeInOut",
                }}
                style={{
                    position: "absolute",
                    inset: 0,
                    borderRadius: "inherit",
                    background:
                        "linear-gradient(90deg, transparent, rgba(255,255,255,0.55), transparent)",
                }}
            />

            <motion.div
                initial={{ x: "-100%" }}
                animate={{ x: "100%" }}
                transition={{
                    duration: 1.4,
                    repeat: Infinity,
                    ease: "easeInOut",
                }}
                style={{
                    position: "absolute",
                    inset: 0,
                    borderRadius: "inherit",
                    background:
                        "linear-gradient(90deg, transparent, rgba(255,255,255,0.65), transparent)",
                }}
            />
        </Box>
    );
};